import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHandler } from 'app/shared/http/http-handler';
import { AppConfiguration } from 'app/shared/settings/app-config';
import { AppConfigService } from 'app/shared/settings/app-config.service';
import { AppConstants } from 'app/shared/settings/app-constants';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  private config: AppConfiguration = this.appSettings.getConfiguration();
  private consts: AppConstants = this.appSettings.getConstants();
  private rootRoute = 'ug/versao';

  constructor(
    private http: HttpHandler,
    private appSettings: AppConfigService,
    private router: Router
  ) { }

  public obterDownloadAtual() {
    const urlApi = `${this.config.apiServiceBaseUri}v1/${this.rootRoute}/download-atual`;
    return this.http.get(urlApi);
  };
}
